import React, { useEffect, useState } from 'react'
import { getOpendAuctions } from '../apis/AuctionEntryApis';
import AuctionEntryItem from '../../../components/AuctionEntry/AuctionEntryItem';
import { useTranslate } from '../../../components/TranslationText';
import SearchBox from '../../../components/SearchBox';


export default function AuctionEntryList() {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const [auctions, setAuctions] = useState([]);
    const { translate } = useTranslate();
    const [searchAuction, setSearchAuction] = useState("");

    useEffect(() => {
        getOpendAuctions().then((res) => {
            setAuctions(res ?? []);
        });
    }, [])


    const diesplayedAuctions = auctions
        .filter((item) => {
            if (searchAuction === "") {
                return item;
            } else if (searchAuction !== "") {
                return item?.nameEn
                    .toLowerCase()
                    .includes(searchAuction.toLowerCase());
            }
        })

    return (
        <div className="col-lg-9 col-md-9 col-sm-12  rtl">
            <div className="row rtl mb-main" >
                <div className="col-sm-6 col-12">
                    <SearchBox
                        isFullWidth
                        onChange={(e) => {
                            setSearchAuction(e.target.value);
                        }}
                        placeholder={translate(
                            "web.searchAuction",
                            "Search By Auction Name"
                        )}
                    />
                </div>
            </div>
            <div className="row">
                {!!diesplayedAuctions && diesplayedAuctions.length > 0
                    ? diesplayedAuctions.map((item, i) => (
                        <AuctionEntryItem i={i} item={item} translate={translate} currentLanguage={currentLanguage} />
                    )) : ''}
            </div>
        </div>
    )
}
